const CurrencyInput = ({ ...props }) => {
  const {value = {}, onChange} = props;
  const handleSelectChange = (e:React.ChangeEvent<HTMLSelectElement>) => {
    onChange({
      ...value,
      currency: e.target.value,
    });
  };

  const handleInputChange = (e:React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      ...value,
      amount: e.target.value === "" ? "" : Number(e.target.value),
    });
  };

  return (
    <div className="flex items-center rounded-md border gap-2">
      <select
        value={value?.currency || ""}
        onChange={handleSelectChange}
        className="p-2 px-4 border font-medium rounded-md bg-gray-100 hover:bg-gray-200 focus:outline-none focus:border-[#1da077] focus:ring-2 focus:ring-[#1da077] text-black"
      >
        {/* <option value="" disabled>
          Select currency
        </option> */}
        <option className="bg-white text-black" value="NPR">
          NPR
        </option>
        <option className="bg-white text-black" value="USD">
          USD
        </option>
        <option className="bg-white text-black" value="INR">
          INR
        </option>
        <option className="bg-white text-black" value="EUR">
          EUR
        </option>
        <option className="bg-white text-black" value="GBP">
          GBP
        </option>
        <option className="bg-white text-black" value="AUD">
          AUD
        </option>
      </select>
      <input
        type="number"
        value={value?.amount || ""}
        onChange={handleInputChange}
        className="border-0 outline-none w-full"
      />
    </div>
  );
};

export default CurrencyInput;
